import { LeftNavGroup } from "../../../straps/base/navigation/LeftNav/LeftNavGroup";
import { useSite } from "@src/context/SitesContext";
import { BuildingSelectionItem } from "./BuildingSelectionItems";
import { useRouteMatch } from "react-router-dom";

export function SelectedBuildingSection() {
  const match = useRouteMatch<{ siteId: string }>("/site/:siteId");
  const siteId = Number(match?.params.siteId);
  const site = useSite(isNaN(siteId) ? null : siteId);

  if (!site) {
    return null;
  }

  return (
    <div className="mt-7">
      <LeftNavGroup title={site.name} iconName="building" active>
        <BuildingSelectionItem title="" siteId={site.id} omitParentComponent />
      </LeftNavGroup>
    </div>
  );
}
